import { gql } from '@apollo/client';

export const PARSER_URL = gql`
    query parseUrlChecking($url: String!) {
        parseUrl(input: { url: $url }) {
            #            creator
            #            created
            #            taffiId
            title
            description

            colors
            images
            sizes
            price
            currency

            #            categories {
            #                id
            #                name
            #            }
            #            tags {
            #                id
            #                name
            #            }
            #            items {
            #                id
            #                variant {
            #                    color
            #                    size
            #                }
            #                data {
            #                    id
            #                    price
            #                }
            #            }
            #            purposes {
            #                id
            #                title
            #            }
            #            ages {
            #                id
            #                title
            #            }
            #            seasons {
            #                id
            #                title
            #            }
            #            gender {
            #                id
            #                title
            #            }
            #            persona {
            #                id
            #                title
            #            }
        }
    }
`;

export const GET_IMAGE_DATA = gql`
    query getImageData($input: GetImageDataInput!) {
        getImageData(input: $input) {
            imageUrl
        }
    }
`;
